@if (!hidden) {
  @if (showExtra) {
    <div class="cookie-banner extra">
      <div class="cookie-content">
        <b class="cookie-title">Cookie Notice</b>
        <p>
          We use cookies to remember your account details, provide a secure login experience, collect statistics to
          optimize site functionality and deliver content and marketing tailored to your interests.
        </p>
        <p class="cookie-text">
          Click <b>“Agree”</b> to accept all cookies or decline by leaving the site. You can view detailed descriptions
          of the types of cookies we use and find information on opt-out options in our
          <a href="https://help.picflow.com/en/articles/5538125" target="_blank" class="primary-link">Cookie Policy</a>.
        </p>
        <button
          appButton
          name="accept"
          location="cookie-banner"
          color="primary"
          (click)="hide()"
          spacing="full"
          height="3"
          shape="round"
        >
          Agree
        </button>
      </div>
    </div>
  } @else {
    <div class="small-cookie-banner-container" [@smallCookieBanner]>
      <div class="small-cookie-banner">
        <p>By continuing, you agree to the use of <span class="clickable" (click)="showExtra = true">Cookies</span>.</p>
        <button
          appButton
          name="accept"
          location="cookie-banner"
          color="primary"
          (click)="hide()"
          shape="round"
          size="1"
          height="1"
          spacing="4"
          data-test-id="agree-cookies"
        >
          Ok
        </button>
      </div>
    </div>
  }
}
